<div class="row">
  <div class="row">
    <div class="field">
      <label soho-label [required]="true">{{'FieldNameLabel' | translate}}</label>
      <input type="text"
        id="customComputeName"
        name="customComputeName"
        class="input-md"
        soho-input
        (ngModelChange)="handleFieldNameEvent($event)"
        soho-alert
        #fieldName
        [ngModel]="customCompute.fieldName"
        data-automation-id="lm-derived-compute-builder-name">
      </div>
    </div>
    <div class="row">
      <div class="compound-field">
        <div class="field"><label soho-label [required]="true">{{'FieldType' | translate}}</label>
        <select
          soho-dropdown
          [ngClass]="'dropdown-sm'"
          (ngModelChange)="handleFieldType($event)"
          noSearch
          id="customComputeFieldType"
          name="customComputeFieldType"
          placeholder="Field Type"
          soho-alert
          #fieldType
          [ngModel]="customCompute.fieldType"
          [attributes]="typeAutomationId">
          @for (option of fieldTypes; track option) {
            <option [value]="option.value">{{option.label}}</option>
          }
        </select>
      </div>
      <div class="field">
        <label soho-label [required]="!isSizeReadOnly">{{'SizeLabel' | translate}}</label>
        <input type="text"
          id="customComputeSize"
          name="customComputeSize"
          class="input-sm"
          maxlength="2"
          soho-input
          [readonly]="isSizeReadOnly"
          (ngModelChange)="handleSizeEvent($event)"
          soho-alert
          #size
          [ngModel]="customCompute.size"
          soho-mask
          [mode]="'number'"
          data-automation-id="lm-derived-compute-builder-size">
        </div>
        <div class="field">
          <label soho-label [required]="!isDecimalReadOnly">{{'DecimalsLabel' | translate}}</label>
          <input type="text"
            id="customComputeDecimal"
            name="customComputeDecimal"
            class="input-sm"
            maxlength="1"
            soho-input
            [readonly]="isDecimalReadOnly"
            (ngModelChange)="handleDecimalEvent($event)"
            soho-alert
            #decimal
            [ngModel]="customCompute.decimal"
            soho-mask
            [mode]="'number'"
            data-automation-id="lm-derived-compute-builder-decimal"
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="field">
          <label>{{ 'DefinitionLabel' | translate }}</label>
          <textarea style="{{ 'min-height: 150px; width: 100%; max-width: none' }}"
            spellcheck="false"
            tabindex="-1"
            id="customComputeDefinition"
            name="customComputeDefinition"
            (ngModelChange)="handleLplTextEvent($event)"
            [resizable]="true"
            [ngModel]="customCompute.computeLpl"
            soho-textarea
            soho-alert
            #definition
            data-automation-id="lm-derived-compute-builder-definition"
          ></textarea>
        </div>
      </div>
    </div>
